import React from 'react';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  toolbarContainer: {
    height: '208px',
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    boxShadow: '0px -3px 6px #00000029',
    // Raise it above resource zoom:
    zIndex: 2
  },
  toolbarPlaceHolder: {
    height: '208px',
    flexGrow: 0,
    flexShrink: 0,
  }
}))

export default ({children}) => {
  const classes = useStyles();
  return <>
    <div className={classes.toolbarPlaceHolder}/>
    <div className={classes.toolbarContainer}>
      {children}
    </div>
  </>
}